import React, { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { LanguageProvider } from "./context/LanguageContext";
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";

// Pages
import LanguageSelectPage from "./pages/LanguageSelectPage";
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import RegisterProfessionalPage from "./pages/RegisterProfessionalPage";
import PaymentPage from "./pages/PaymentPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import DirectoryPage from "./pages/DirectoryPage";
import ProfessionalProfilePage from "./pages/ProfessionalProfilePage";
import DashboardPage from "./pages/DashboardPage";
import MessagesPage from "./pages/MessagesPage";
import AdminPage from "./pages/AdminPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import SubscriptionPage from "./pages/SubscriptionPage";
import SubscriptionSuccessPage from "./pages/SubscriptionSuccessPage";

function App() {
  const [languageSelected, setLanguageSelected] = useState(() => {
    return localStorage.getItem('automat_language_selected') === 'true';
  });

  // Check if we're on admin route
  const isAdminRoute = window.location.pathname === '/admin';

  // Show language selection only if not selected and not on admin route
  if (!languageSelected && !isAdminRoute) {
    return (
      <LanguageProvider>
        <LanguageSelectPage onLanguageSelect={() => setLanguageSelected(true)} />
        <Toaster position="top-right" richColors />
      </LanguageProvider>
    );
  }

  return (
    <LanguageProvider>
      <AuthProvider>
        <div className="App min-h-screen flex flex-col" style={{ fontFamily: 'Inter, sans-serif' }}>
          <BrowserRouter>
            <Routes>
              {/* Admin route - no navbar/footer */}
              <Route path="/admin" element={<AdminPage />} />
              
              {/* Regular routes with navbar/footer */}
              <Route path="/*" element={
                <>
                  <Navbar />
                  <main className="flex-1">
                    <Routes>
                      <Route path="/" element={<LandingPage />} />
                      <Route path="/login" element={<LoginPage />} />
                      <Route path="/register" element={<RegisterPage />} />
                      <Route path="/register-professional" element={<RegisterProfessionalPage />} />
                      <Route path="/payment" element={<PaymentPage />} />
                      <Route path="/payment-success" element={<PaymentSuccessPage />} />
                      <Route path="/directory" element={<DirectoryPage />} />
                      <Route path="/professional/:id" element={<ProfessionalProfilePage />} />
                      <Route path="/dashboard" element={<DashboardPage />} />
                      <Route path="/messages" element={<MessagesPage />} />
                      <Route path="/subscription" element={<SubscriptionPage />} />
                      <Route path="/subscription-success" element={<SubscriptionSuccessPage />} />
                      <Route path="/terms" element={<TermsPage />} />
                      <Route path="/privacy" element={<PrivacyPage />} />
                    </Routes>
                  </main>
                  <Footer />
                </>
              } />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </div>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
